import { memo } from 'react'
import { createPortal } from 'react-dom'
import { PlayerTrailer } from '../PlayerTrailer/ui'

export const TrailerPlayerPortal = memo(
  ({ el }: { el?: HTMLDivElement | null }) => {
    if (!el) return <></>

    return createPortal(<PlayerTrailer />, el, `trailer_player`)
  }
)
TrailerPlayerPortal.displayName = 'TrailerPlayerPortal'
